import { ThemeProvider as MuiThemeProvider, type Theme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { defaultTheme } from "./defaultTheme.ts";

export function ThemeProvider({
  children,
  theme = defaultTheme,
}: {
  children: ReactNode;
  theme?: Theme;
}) {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
